<template>
  <v-tooltip right>
    <template v-slot:activator="{on, attrs}">
      <v-btn 
          v-on="on"
          v-bind="attrs" 
          pill outlined 
          color="#121212" 
          x-small 
          class="btn-learn mx-auto rounded-pill" 
          @click="emitOpen"
        >
        <v-icon color="grey">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    Click to expand
  </v-tooltip>
</template>
<script>
export default {
  name: "ViewMore",
  methods: {
    emitOpen() {
      this.$emit("open", {
        title: this.title,
        component: this.component,
        content: this.content,
      });
    },
  },
};
</script>

<style>
.btn-learn{
  max-width: 32px;
}
.btn-learn:hover {
  background-color: #9c9c9c66;
  transition:all .3s ease-out;
}
</style>